module.exports = "<template>\r\n\t<md-input value.bind=\"value\"></md-input>\r\n</template>";